import React, { useEffect, useState } from "react";
import "../../../../css/ProviderNetwork/ReportProviderIssueModal.css";
import PrimaryButton from "../../../DesignSystem/Buttons/PrimaryButton";
import SecondaryButton from "../../../DesignSystem/Buttons/SecondaryButton";
import ProviderInput from "../components/ProviderInput";
import {ReactComponent as CloseIcon} from "../../../../assets/icons/close.svg";
import { useUserEmail } from "../../../../context/UserEmailContext";

const ISSUE_TYPE_OPTIONS = [
  {
    value: "missing_information",
    label: "Missing Information",
  },
  {
    value: "incorrect_information",
    label: "Incorrect Information",
  },
];

const IssueTypeToggle = ({ value, onChange }) => {
  return (
    <div className="ReportProviderIssueModal__Field">
      <div className="provider-network-label">Issue found</div>

      <div className="ReportProviderIssueModal__ToggleGroup">
        {ISSUE_TYPE_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`ReportProviderIssueModal__Toggle FP_Content black ${
              value === option.value ? "is-active" : ""
            }`}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

const ReportProviderIssueModal = ({
  isOpen,
  provider,
  onClose,
  onSubmit,
  loading = false,
}) => {
  const [formData, setFormData] = useState({
    providerName: "",
    issueType: "missing_information",
    details: "",
  });
const { userEmail } = useUserEmail();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) return;

    setFormData({
      providerName: provider?.providerName || provider?.name || "",
      issueType: "missing_information",
      details: "",
    });

    setErrors({});
  }, [isOpen, provider]);

  if (!isOpen) return null;

  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nextErrors = {};

    if (!formData.providerName.trim()) {
      nextErrors.providerName = "Provider name is required.";
    }

    if (!formData.details.trim()) {
      nextErrors.details = "Please enter the details.";
    }

    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) return;

      await onSubmit({
        providerName: formData.providerName.trim(),
        issueType: formData.issueType,
        details: formData.details.trim(),
        providerId: provider?.id || "",
        reportedBy: userEmail || localStorage.getItem("userEmail") || "",
        submittedAt: new Date().toISOString(),
      });
  };

  return (
    <div className="ReportProviderIssueModal__Overlay">
      <form className="ReportProviderIssueModal" onSubmit={handleSubmit}>
        <div className="ReportProviderIssueModal__Header">
          <div className="ReportProviderIssueModal__HeaderText">
            <div className="FP_Subtitle_Semibold primary">Report An Issue</div>
            <div className="FP_Help_Text">
              Please let us know if there is an issue with the information found
              in the Provider Index.
            </div>
          </div>

          <button
            type="button"
            className="ReportProviderIssueModal__Close"
            onClick={onClose}
            disabled={loading}
          >
            <CloseIcon />
          </button>
        </div>

        <IssueTypeToggle
          value={formData.issueType}
          onChange={(value) => updateField("issueType", value)}
        />

        {/* <div className="ReportProviderIssueModal__Body"> */}
        <ProviderInput
          label="Provider Name"
          required
          value={formData.providerName}
          placeholder="Enter provider name"
          error={errors.providerName}
          onChange={(value) => updateField("providerName", value)}
        />

        <ProviderInput
          label="Details"
          required
          type="textarea"
          rows={6}
          value={formData.details}
          placeholder="Enter issue details"
          error={errors.details}
          onChange={(value) => updateField("details", value)}
        />

        <div className="ReportProviderIssueModal__Footer">
          <SecondaryButton
            type="button"
            label="Cancel"
            onClick={onClose}
            disabled={loading}
          />

          <PrimaryButton
            type="submit"
            label={loading ? "Submitting..." : "Submit"}
            disabled={loading}
          />
        </div>
      </form>
    </div>
  );
};

export default ReportProviderIssueModal;
